// Generated by https://quicktype.io

import { MiscGeneral } from "./MiscGeneral";

export class VenueCoreConfig {
	venueKey: number;
	venueName: string;
	timezoneOffset: number;
	data: boolean;
	checks: boolean;
	onlineOrder: boolean;
	timecards: boolean;
	notifications: boolean;
	checkDate: string;
	backpollComplete: boolean;
	excessivePosting: string;
	MiscGeneral: MiscGeneral;

	public constructor(init?: Partial<VenueCoreConfig>) {
		Object.assign(this, init);
	}
}
